import React from 'react';
import { OidcProvider, OidcProviderProps } from 'redux-oidc';
import userManager from '../../util/usermanager';
import { AppState } from '../../store';

interface OidcWrapperProps extends OidcProviderProps<AppState> {
  children: any;
}

const OidcWrapper: React.FC<OidcWrapperProps> = ({ store, children }) => {
  if (typeof window !== `undefined` && typeof userManager !== 'undefined') {
    return (
      <OidcProvider store={store} userManager={userManager}>
        {children}
      </OidcProvider>
    );
  }

  return children;
};

export default OidcWrapper;
